/* TG Racing v26 — quick add, add-ons, sticky ATC, delivery confirmation guard, drawer split-shipment note */
(function () {
  'use strict';
  async function refreshCount() {
    try {
      var c = await (await fetch('/cart.js')).json();
      var el = document.querySelector('.cart-count');
      if (!el && c.item_count > 0) { var icon = document.querySelector('.cart-icon'); if (icon) { el = document.createElement('span'); el.className = 'cart-count'; icon.appendChild(el); } }
      if (el) el.textContent = c.item_count;
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('tg:cart-updated'));
  }
  async function addItem(id, ship) {
    var props = {}; if (ship) props['Shipping estimate'] = ship;
    var r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: props }] }) });
    if (!r.ok) throw new Error('add failed');
    await refreshCount();
  }

  /* Delivery confirmation: block add-to-cart / checkout until the box is ticked, even if an app intercepts the click */
  function guard(e) {
    var btn = e.target.closest('button[type=submit], input[type=submit], .tg-sticky-atc button');
    if (!btn) return;
    var form = btn.form || (btn.closest('.tg-sticky-atc') ? document.getElementById('ProductForm') : null);
    if (!form) return;
    var box = form.querySelector('[data-tg-ack-box]');
    if (box && !box.checked) {
      e.preventDefault(); e.stopImmediatePropagation();
      var wrap = box.closest('[data-tg-ack]'); if (wrap) wrap.classList.add('is-missing');
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (box.reportValidity) box.reportValidity();
    }
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', function (e) {
    var box = e.target.querySelector && e.target.querySelector('[data-tg-ack-box]');
    if (box && !box.checked) { e.preventDefault(); e.stopImmediatePropagation(); box.reportValidity && box.reportValidity(); }
  }, true);

  /* Card quick-add (capture phase so the legacy handler never runs) */
  document.addEventListener('submit', async function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('product-card-form')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var id = form.querySelector('input[name="id"]'); if (!id) return;
    var btn = form.querySelector('.btn-add-to-cart'); if (btn) btn.classList.add('is-loading');
    try { await addItem(id.value, form.dataset.ship); if (btn) btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>'; } catch (err) { console.error(err); }
    if (btn) btn.classList.remove('is-loading');
  }, true);

  /* Add-ons (Shiftlock page) */
  document.addEventListener('click', async function (e) {
    var b = e.target.closest('[data-tg-addon]'); if (!b) return;
    e.preventDefault(); b.disabled = true;
    try { await addItem(b.dataset.tgAddon, b.dataset.ship); b.textContent = 'Added ✓'; b.classList.add('is-added'); } catch (err) { b.disabled = false; }
  });

  /* Sticky ATC (mobile) */
  var sticky = document.querySelector('.tg-sticky-atc');
  var mainAtc = document.querySelector('.product-atc-row');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { en.forEach(function (x) { sticky.classList.toggle('is-visible', !x.isIntersecting && x.boundingClientRect.top < 0); }); }).observe(mainAtc);
    var sb = sticky.querySelector('button');
    sb && sb.addEventListener('click', function () { var m = document.querySelector('#ProductForm .btn-atc'); if (m) m.click(); });
  }

  /* Cart drawer (iCart): delivery note when the cart has more than one shipper or a slow item */
  var NOTE_ID = 'tg-drawer-split-note', busy = false;
  async function annotateDrawer() {
    if (busy) return;
    var drawer = document.querySelector('.icart-drawer, #icart-drawer, [class*="icart"][class*="drawer"], [class*="icart"][class*="side"]');
    if (!drawer || drawer.offsetParent === null || drawer.querySelector('#' + NOTE_ID)) return;
    busy = true;
    try {
      var c = await (await fetch('/cart.js')).json();
      var vendors = {}, tg = false, slow = false;
      c.items.forEach(function (it) {
        var v = (it.vendor || '').trim(); vendors[v] = 1; if (v === 'TG Racing') tg = true;
        if (it.properties && it.properties['Delivery estimate acknowledged']) slow = true;
      });
      if (Object.keys(vendors).length > 1 || slow) {
        var note = document.createElement('div'); note.id = NOTE_ID; note.className = 'tg-split-note';
        note.innerHTML = '<div><strong>Items ship separately and may arrive on different dates.</strong>' + (tg ? 'TG Racing items usually ship in 1–2 business days. ' : '') + 'Partner-brand items ship from each brand on their own timeline, which can be several weeks. <a href="/cart" style="text-decoration:underline">Review delivery estimates</a> · <a href="/pages/shipping-times" style="text-decoration:underline">Shipping times</a></div>';
        var anchor = drawer.querySelector('[class*="footer"], [class*="checkout"], [class*="subtotal"]');
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(note, anchor); else drawer.appendChild(note);
      }
    } catch (e) {}
    busy = false;
  }
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(annotateDrawer, 250); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('tg:cart-updated', function () { var o = document.getElementById(NOTE_ID); if (o) o.remove(); setTimeout(annotateDrawer, 400); });
})();